export default __webpack_public_path__ + "d59a9e5f3697028e66cf92084643e3b5.svg";